import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PublicRoute = () => {
    const token = localStorage.getItem('token');
    const userStr = localStorage.getItem('user');

    // If user is logged in, redirect to their dashboard
    if (token && userStr) {
        try {
            const user = JSON.parse(userStr);

            if (user.role === 'admin') {
                return <Navigate to="/admin/dashboard" replace />;
            } else if (user.role === 'farmer') {
                return <Navigate to="/farmer/dashboard" replace />;
            } else {
                // Default for consumer or others
                return <Navigate to="/consumer/dashboard" replace />;
            }
        } catch (e) {
            // If user data is corrupted, clear it and allow access
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            return <Outlet />;
        }
    }

    // If not logged in, allow access to the route
    return <Outlet />;
};

export default PublicRoute;
